import Loading from "components/common/loading/Loading";
import NoData from "components/common/NoData";
import { DropdownInputPropsType } from "types/form-types";
import DropdownItemInput from "./DropdownItemInput";

const DropdownItemsInput = <T, TSort> (props: DropdownInputPropsType<T, TSort> & {
    data: T[], 
    loading: boolean, 
    onItemClick: (i: T, event: React.MouseEvent<HTMLLIElement> | React.KeyboardEvent<HTMLLIElement>) => void,
}) => {    
    if(props.loading) {
        return <ul>
            <li>
                <Loading />
            </li>
        </ul>
    }

    if(!props.data?.length) {
        return <ul>
            <li>
                <NoData />
            </li>
        </ul>
    }

    return <ul>{props.data.map(i => {
        return (<DropdownItemInput 
            key={`dropdown-list-item-${props.getItemId(i)}`} 
            {...props}
            isActive={props.value && props.getItemId(i) === props.getItemId(props.value) ? true : false}
            isFocused={false}
            item={i}
        />);
    })}</ul>;
}

export default DropdownItemsInput;
